/**
  * 锦盒 接口的统一出口
  */
import axios from '../http' // 导入http中创建的axios实例
import qs from 'qs' // 根据需求是否导入qs模块，把请求字段直接映射过来
const index = {
	// 验证充值卡 是否可用
	verfyCard(params){
		return axios.get('/manghe/verfy/chargecard', { params: params })
	},
	// 绑定充值卡
	bindCard(params){
		return axios.post('/manghe/h5bind/chargecard', qs.stringify(params))
	}
}
// 导出接口
export default index